import { FC, ForwardedRef, forwardRef, PropsWithChildren } from 'react';

import styles from './RefTextInput.module.scss';

type Props = any;
// eslint-disable-next-line react/display-name
const RefTextInput: FC<Props> = forwardRef((props: PropsWithChildren<Props>, ref: ForwardedRef<any>) => {
  const { children, className, size, ...inputProps } = props;
  return (
    <input
      className={`${styles.input_item} ${className} ${size === 'width1' && 'util-formWidth1'}`}
      ref={ref}
      {...inputProps}
    />
  );
});

export default RefTextInput;
